import { database, auth } from "../../firebase";

export function authUser(userName, password) {
  auth
    .signInWithEmailAndPassword(userName, password)
    .then((resp) => {
      debugger;
    })
    .catch((err) => false);
}

export function registerUser(userName, password) {
  auth
    .createUserWithEmailAndPassword(userName, password)
    .then((user) => {
        debugger;
    })
    .catch((err) => false);
}

export function getUser(uid) {
  return database
    .ref(`/users/${uid}`)
    .once("value")
    .then((snapshot) => {
      return snapshot.val();
    });
}

export function getCreditzLength(uid) {
  return database
    .ref(`/user-posts/${uid}`)
    .once("value")
    .then((snapshot) => {
      const array = [];
      snapshot.forEach((childSnapshot) => {
        array.push(childSnapshot.key);
      });
      return array;
    });
}

export function getUserMusics(id) {
  return database
    .ref(`/posts/${id}`)
    .once("value")
    .then((snapshot) => {
      return { id, ...snapshot.val() };
    });
}

export function getAchivements(id) {
  return database
    .ref(`/achievements/${id}`)
    .once("value")
    .then((snapshot) => {
      const array = [];
      snapshot.forEach((childSnapshot) => {
        const childKey = childSnapshot.key;
        const childData = childSnapshot.val();
        array.push({ childKey, childData });
      });
      return array;
    });
}

export function updateUserStatus(currentUser) {
  return database
    .ref(`/users/${currentUser.uid}`)
    .update({
      ...currentUser,
    })
    .then(() => {
      return true;
    })
    .catch(() => {
      return false;
    });
}

export function getAllAchievements(uid) {
  return database
    .ref(`/user-achievements/${uid}`)
    .once("value")
    .then((snapshot) => {
      const array = [];
      snapshot.forEach((childSnapshot) => {
        const childKey = childSnapshot.key;
        const childData = childSnapshot.val();
        array.push({ id: childSnapshot.key, ...childData });
      });
      return array;
    });
}
